<script setup>
import { useSession } from '@/stores/session'

const session = useSession()

// Ce filtre ne fait que RESTREINDRE l'affichage. Le périmètre, lui, vient de
// la jointure côté API : choisir une société à laquelle on n'est pas
// rattaché ne rendrait rien — le `<select>` ne propose d'ailleurs que celles
// que l'API a rapportées.
</script>

<template>
  <label class="discret" style="display:flex;align-items:center;gap:.4rem;margin:0;font-weight:400;">
    <span>Marque</span>
    <select v-model="session.societeFiltre" style="width:auto;padding:.3rem .5rem;">
      <option value="">Toutes</option>
      <option v-for="s in session.societes" :key="s.ui" :value="s.ui">
        {{ s.libelle }}
      </option>
    </select>
  </label>
</template>
